import {config} from "../../../app/config/main";

export const storeToken = (data) => {
    // localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data));
    if(!config?.authSetting?.axiosObject)
        alert('some thing went wrong')
    // throw Error("axiosObject need to be set under authSettings inside app/config/main.js");
    else
        config.authSetting.axiosObject.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
        config.authSetting.axiosObject.defaults.headers.common['Ccode'] = data?.currentBranch?.FL_COMPANY_CODE;
        config.authSetting.axiosObject.defaults.headers.common['Finyear'] = data.FINYEAR;
    };

export const removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    if(!config?.authSetting?.axiosObject)
    alert('some thing went wrong')
    // throw Error("axiosObject need to be set under authSettings inside app/config/main.js");
    else
        delete config.authSetting.axiosObject.defaults.headers.common['Authorization'];
};